import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { useSelectLang } from "../model/useSelectLang";
import { useTranslation } from "react-i18next";

import UaIcon from "../../../../public/flags/ua.svg?react";
import UsIcon from "../../../../public/flags/us.svg?react";

const itemClassName =
  "mt-0 gap-3 text-white font-body text-[16px] cursor-pointer hover:bg-[#4f487f] focus:bg-[#4f487f] active:bg-[#4b4380]";

function RuLanguageIcon() {

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className="shrink-0"
      style={{ width: "24px", height: "24px" }}
    >
      <path
        d="M12.0002 21.0004C16.1928 21.0004 19.7159 18.1335 20.7161 14.2532M12.0002 21.0004C7.80752 21.0004 4.28445 18.1335 3.2843 14.2532M12.0002 21.0004C14.4855 21.0004 16.5003 16.9708 16.5003 12.0002C16.5003 7.02952 14.4855 3 12.0002 3M12.0002 21.0004C9.51485 21.0004 7.50009 16.9708 7.50009 12.0002C7.50009 7.02952 9.51485 3 12.0002 3M20.7161 14.2532C20.9016 13.5331 21.0004 12.7782 21.0004 12.0002C21.0004 10.3948 20.58 8.88755 19.8434 7.58254M20.7161 14.2532C18.1337 15.685 15.1621 16.5003 12.0002 16.5003C8.83822 16.5003 5.86668 15.685 3.2843 14.2532M3.2843 14.2532C3.09872 13.5331 3 12.7782 3 12.0002C3 10.3948 3.42033 8.88755 4.15695 7.58254M12.0002 3C15.3654 3 18.2993 4.84698 19.8434 7.58254M12.0002 3C8.63492 3 5.70105 4.84698 4.15695 7.58254M19.8434 7.58254C17.74 9.40052 14.9985 10.5002 12.0002 10.5002C9.00184 10.5002 6.26034 9.40052 4.15695 7.58254"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


export const ChangeLang = () => {
  const { t } = useTranslation("userProfile");
  const { lang, changeLanguage } = useSelectLang();
  const code = lang.split("-")[0];
  const FlagIcon = code === "ua" ? UaIcon : UsIcon;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="relative flex gap-2 items-center rounded-[100px] px-3 py-2 glass-effect font-body font-medium text-white text-[16px] border-0 bg-transparent cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-white/40"
        >
          {code === "ru" ? (
            <RuLanguageIcon />
          ) : (
            <FlagIcon
              className="rounded-full size-6 shrink-0"
              aria-hidden
            />
          )}
          <span className="translate-y-px">{lang.toUpperCase()}</span>
          <svg
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              opacity="0.9"
              d="M10.75 0.75L5.75 5.75L0.75 0.75"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-48 bg-[#39326e] p-2"
      >
        <DropdownMenuItem
          onSelect={() => changeLanguage("en")}
          className={itemClassName}
        >
          <UsIcon className="rounded-full size-6 shrink-0" />
          <span>{t("languages.en")}</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => changeLanguage("ua")}
          className={itemClassName}
        >
          <UaIcon className="rounded-full size-6 shrink-0" />
          <span>{t("languages.ua")}</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => changeLanguage("ru")}
          className={itemClassName}
        >
          <RuLanguageIcon />
          <span>{t("languages.ru")}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};